module.exports = __webpack_public_path__ + "res/34-img_bg_l.366172a58e0f32db362a5a86c51c3ab3.png";